import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TimelineMarkerComponent } from './components/timeline-marker/timeline-marker.component';
import { VideojsMediaPlayerComponent } from './components/videojs-media-player/videojs-media-player.component';

@NgModule({
  imports: [CommonModule, PortalModule],
  exports: [VideojsMediaPlayerComponent],
  declarations: [VideojsMediaPlayerComponent, TimelineMarkerComponent],
})
export class VideoJsMediaPlayerModule {}
